import { Component, OnInit, ViewChild } from '@angular/core';
import { ABMRolesService } from '../../../services';
import { MdDialogRef } from '@angular/material';
import { Router } from '@angular/router';

import { PATH_ABM_ACOPIO_DETAIL } from '../../../navigation/navigation.module';
import {  FormBuilder, FormControl } from '@angular/forms';
import { isNull } from 'util';

@Component({
  selector: 'app-new-acopio-dialog',
  templateUrl: './new-acopio-dialog.component.html',
  styleUrls: ['./new-acopio-dialog.component.scss']
})
export class NewAcopioDialogComponent {

  public name: string;
  public an8: string;
  public formNewAcopio = this.formBuilder.group({
    'acopio': new FormControl(),
    'an8': new FormControl(),
    'name': new FormControl(),
    'planComercial': new FormControl()
  })  

  constructor(private abmService: ABMRolesService,
              private dialogRef: MdDialogRef<NewAcopioDialogComponent>,
              private router: Router,
              public formBuilder: FormBuilder) { }

  onSubmit() {
    this.abmService.setTmpAcopio({
      "Id": Number(this.formNewAcopio.get('an8').value),
      "ParentId": isNull(this.formNewAcopio.get('acopio').value) 
        ? null 
        : this.formNewAcopio.get('acopio').value.map(x => x.Id)[0],
      "AcopioNombre": this.formNewAcopio.get('name').value,
      "CuentasIds": [],
      "CategoriaId": 1,
      "PlanComercialVisibility": Boolean(this.formNewAcopio.get('planComercial').value),
    })
    this.dialogRef.close(true);
    this.router.navigate([PATH_ABM_ACOPIO_DETAIL]);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/new-acopio-dialog/new-acopio-dialog.component.ts